export default __webpack_public_path__ + "static/media/31-Beijing.7c961aa9.jpg";